import { api } from "@/lib/api";

const CHUNK_SIZE = 2 * 1024 * 1024;

function randomId() {
  return [...crypto.getRandomValues(new Uint8Array(16))].map((b) => b.toString(16).padStart(2, "0")).join("");
}

// Lädt eine Datei in 4-MB-Teilen hoch (umgeht Proxy-Limits). store: "file" (Objekt-Speicher) | "local" (für Reel-Jobs)
export async function uploadFileChunked(file, { onProgress, store = "file", isAborted, accountKey, folderTitle } = {}) {
  const uploadId = randomId();
  const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  let done = 0;

  const sendChunk = async (i) => {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", i);
    fd.append("chunk", file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE), "chunk.bin");
    let attempt = 0;
    for (;;) {
      if (isAborted?.()) throw new Error("upload_aborted");
      try {
        await api.post("/uploads/chunk", fd, { timeout: 90000 });
        break;
      } catch (e) {
        attempt += 1;
        if (attempt >= 4) throw e;
        await new Promise((r) => setTimeout(r, 1500 * attempt));
      }
    }
    done += 1;
    onProgress?.(Math.round((done / total) * 100));
  };

  // 2 Chunks parallel — schneller, ohne langsame Mobilverbindungen zu überlasten
  let next = 0;
  const workers = Array.from({ length: Math.min(2, total) }, async () => {
    while (next < total) {
      if (isAborted?.()) throw new Error("upload_aborted");
      const i = next;
      next += 1;
      await sendChunk(i);
    }
  });
  await Promise.all(workers);

  if (isAborted?.()) throw new Error("upload_aborted");
  const fd = new FormData();
  fd.append("upload_id", uploadId);
  fd.append("filename", file.name);
  fd.append("total", total);
  fd.append("store", store);
  fd.append("account_key", accountKey || localStorage.getItem("rl_account") || "");
  fd.append("folder_title", folderTitle || "Allgemein");
  const { data } = await api.post("/uploads/complete", fd, { timeout: 600000 });
  return data;
}
